<template>
  <div class="main-content affiliate affiliateSign">
      <h4 class="textTitle">Register as Affiliate</h4>
    <div class="banner">
      <div class="banner-ico"></div>
    </div>

   <div class="affiliateSign-form">
     <el-form
         ref="contactForm"
         :model="contactForm"
         :rules="contactRules"
     >
       <el-form-item prop="first_name" label="First name">
         <el-input v-model="contactForm.first_name"></el-input>
       </el-form-item>
       <el-form-item prop="last_name" label="Last name">
         <el-input v-model="contactForm.last_name"></el-input>
       </el-form-item>
       <el-form-item prop="email" label="Email">
         <el-input v-model="contactForm.email"></el-input>
       </el-form-item>
       <el-form-item prop="message" label="Message">
         <el-input
             v-model="contactForm.message"
             type="textarea"
             :rows="16"
             resize="none"
         ></el-input>
       </el-form-item>
       <el-form-item>
         <button class="button affiliate-btn" type="button" :disabled="butDisabled" @click="submit">
           Submit
         </button>
       </el-form-item>
     </el-form>
   </div>
  </div>
</template>

<script>
import {emailContactUs} from "@/request/api"
export default {
  name: "home",
  components: {},
  data() {
    return {
      search:'',
      butDisabled: false,
      contactForm: {
        // problem_class_id: null,
        first_name: '',
        last_name: '',
        email: '',
        message: ''
      },
      contactRules: {
        // problem_class_id: { required: true, message: 'Class is required', trigger: 'blur' },
        first_name: { required: true, message: 'First Name is required', trigger: 'blur' },
        last_name: { required: true, message: 'Last Name is required', trigger: 'blur' },
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
        ]
      }
    };
  },
  created() {

  },
  methods: {

    submit() {
      var that = this
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          // //發送聯繫email
          let data = that.contactForm;
          let myheaders = {headers : {"pc":true,"content-type":"multipart/form-data"}};
          emailContactUs(data, myheaders).then(function(res){
            if (res.code == 200 || res.code == "200" || res.code == "ok") {
              that.$alert(res.msg, '', {
                confirmButtonText: '確定',
                customClass:'affiliate-alert',
                callback: action => {
                  // 確定後執行**
                  that.$router.push('/');
                }
              });
            }
            else {
              that.$message.error(res.msg);
            }
          });
        } else {

          return false
        }
      })
    },
  },
  watch:{

  }
}
</script>

<style lang="less" scoped>
p{color: #ffffff;}
</style>
